interface Props {
  steps: string[];
  onSelect: (step: string) => void;
}

export function NextStepButtons({ steps, onSelect }: Props) {
  if (steps.length === 0) return null;

  return (
    <div className="next-steps">
      <span className="next-steps-label">Suggested next steps:</span>
      <div className="next-steps-buttons">
        {steps.slice(0, 3).map((step, i) => (
          <button
            key={i}
            className="next-step-btn"
            onClick={() => onSelect(step)}
          >
            {step}
          </button>
        ))}
      </div>
    </div>
  );
}
